import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component({
    template: require('./radar-state-info.html')
})
export class RadarStateInfo extends Vue {

    @Prop()
    private severity: string;

    @Prop()
    private title: string;

}
